export { EventDetailTitleRow } from "./EventDetailTitleRow";
